import { render } from "./ViewIntro.vue?vue&type=template&id=40393cd4&scoped=true"
import script from "./ViewIntro.vue?vue&type=script&lang=ts"
export * from "./ViewIntro.vue?vue&type=script&lang=ts"

import "./ViewIntro.vue?vue&type=style&index=0&id=40393cd4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-40393cd4"

export default script